// removed by extract-text-webpack-plugin
module.exports = {"container":"ResetDevicePasswordModal-container","title":"ResetDevicePasswordModal-title"};